const normalizeStageKey = (stage: string) => stage.trim().toLowerCase().replace(/\s+/g, "_");

const stageColorTheme: Record<string, { text: string; tint: string; progress: string; dot: string }> = {
  cv_submitted: {
    text: "text-gray-700 dark:text-gray-300",
    tint: "bg-gray-100 text-gray-700 dark:bg-gray-900/60 dark:text-gray-200",
    progress: "bg-gray-500",
    dot: "bg-gray-500",
  },
  assessment_sent: {
    text: "text-blue-700 dark:text-blue-300",
    tint: "bg-blue-100 text-blue-700 dark:bg-blue-950/50 dark:text-blue-200",
    progress: "bg-blue-500",
    dot: "bg-blue-500",
  },
  assessment_started: {
    text: "text-indigo-700 dark:text-indigo-300",
    tint: "bg-indigo-100 text-indigo-700 dark:bg-indigo-950/50 dark:text-indigo-200",
    progress: "bg-indigo-500",
    dot: "bg-indigo-500",
  },
  assessment_completed: {
    text: "text-teal-700 dark:text-teal-300",
    tint: "bg-teal-100 text-teal-700 dark:bg-teal-950/50 dark:text-teal-200",
    progress: "bg-teal-500",
    dot: "bg-teal-500",
  },
  selected: {
    text: "text-amber-700 dark:text-amber-300",
    tint: "bg-amber-100 text-amber-700 dark:bg-amber-950/60 dark:text-amber-200",
    progress: "bg-amber-500",
    dot: "bg-amber-500",
  },
  offered: {
    text: "text-violet-700 dark:text-violet-300",
    tint: "bg-violet-100 text-violet-700 dark:bg-violet-950/50 dark:text-violet-200",
    progress: "bg-violet-500",
    dot: "bg-violet-500",
  },
  accepted: {
    text: "text-green-700 dark:text-green-300",
    tint: "bg-green-100 text-green-700 dark:bg-green-950/60 dark:text-green-200",
    progress: "bg-green-500",
    dot: "bg-green-500",
  },
  joined: {
    text: "text-slate-700 dark:text-slate-300",
    tint: "bg-slate-100 text-slate-700 dark:bg-slate-900/60 dark:text-slate-200",
    progress: "bg-slate-700",
    dot: "bg-slate-600",
  },
};

const fallbackTheme = {
  text: "text-gray-700 dark:text-gray-300",
  tint: "bg-gray-100 text-gray-700 dark:bg-gray-900/60 dark:text-gray-200",
  progress: "bg-gray-500",
  dot: "bg-gray-500",
};

export const getStageTheme = (stageLabel: string) => {
  return stageColorTheme[normalizeStageKey(stageLabel)] ?? fallbackTheme;
};
